'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './profile.routes';

export class ProfileComponent {
  user = {};
  residencyRelations = {};

  datepickerOpened = {};

  /*@ngInject*/
  constructor(Auth, User, dialogs, $q, $stateParams, SettingsService) {
    this.Auth = Auth;
    this.dialogs = dialogs;
    this.$q = $q;

    SettingsService.getByName({name: 'config.app'}, settings => {
      var appConfig = settings.data;

      this.config = appConfig;
      this.gender = appConfig.gender;
      this.phoneTypes = appConfig.phoneTypes;
      this.socialMediaTypes = appConfig.socialMediaTypes;
      this.mailTypes = appConfig.mailTypes;
      this.addressTypes = appConfig.addressTypes;
      this.labelPrivate = appConfig.profileLabelPrivate || 'Private';
      this.labelPublic = appConfig.profileLabelPublic || 'Public';
    });

    // If set, this profile is not my own - you look at an other user's profile
    this.userId = $stateParams.id;

    if (this.userId == 'unknown') {
      this.unknown = true;
      return;
    }

    if (this.userId) {

      // foreign profile
      this.isForeignProfile = true;

      User.get({id: this.userId}, user => {
        this.user = user;

        this.isRealtorProfile = this.user.role.indexOf("realtor") != -1;
      });

    } else {

      // own profile
      Auth.getCurrentUser()
        .then(user => {
          this.user = user;
        });

    }

  }

  formatDialogElementInfo(elmInfo) {
    return "<br/><br/><b>"+elmInfo+"</b>";
  }

  addPhone() {
    this.user.profile.phone.push({
      type: this.config.defaultPhoneType,
      number: '',
      private: false
    });
  };

  removePhone(idx) {
    var phone = this.user.profile.phone[idx];
    var phoneString = phone.type + " " + phone.number;

    var dlg = this.dialogs.confirm(
      "Remove phone number?",
      "Do you really want to delete this phone number?" + this.formatDialogElementInfo(phoneString));
    dlg.result.then(() => {
      this.user.profile.phone.splice(idx,1);
      this.saveChanges();
    }, () => {
      // Cancel
    });
  }

  addMail() {
    this.user.profile.email.push({
      type: this.config.defaultMailType,
      address: '',
      private: false
    });
  };

  removeMail(idx) {
    var mail = this.user.profile.email[idx];
    var mailString = mail.type + " " + mail.address;

    var dlg = this.dialogs.confirm(
      "Remove email?",
      "Do you really want to delete this email address?"+ this.formatDialogElementInfo(mailString));
    dlg.result.then(() => {
      this.user.profile.email.splice(idx,1);
      this.saveChanges();
    }, () => {
      // Cancel
    });
  }

  addSocialMedia() {
    this.user.profile.socialMedia.push({
      type: this.config.defaultSocialMediaType,
      link: ''
    });
  };

  removeSocialMedia(idx) {
    var social = this.user.profile.socialMedia[idx];
    var socialString = social.type + " " + social.link;

    var dlg = this.dialogs.confirm(
      "Remove social link?",
      "Do you really want to delete this social media entry?" + this.formatDialogElementInfo(socialString));
    dlg.result.then(() => {
      this.user.profile.socialMedia.splice(idx,1);
      this.saveChanges();
    }, () => {
      // Cancel
    });
  }

  addAddress() {
    this.user.profile.address.push({
      type: this.config.defaultAddressType
    });
  };

  removeAddress(idx) {
    var address = this.user.profile.address[idx];
    var addressString = (address.street || '') + "<br/>"
      + (address.street2 || '' ) + "<br/>"
      + (address.city || '') + " " + (address.state || '')  + " " + (address.zip || '') + "<br/>"
      + (address.country || '');

    var dlg = this.dialogs.confirm(
      "Remove address?",
      "Do you really want to delete this address?" + this.formatDialogElementInfo(addressString));
    dlg.result.then(() => {
      this.user.profile.address.splice(idx,1);
      this.saveChanges();
    }, () => {
      // Cancel
    });
  }

  saveChanges() {
    this.Auth.updateUser(this.user);
  }

  checkValidPhone(phoneNumber) {
    var reUsPhoneNumber = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
    if (!reUsPhoneNumber.test(phoneNumber)) {
      return "Please enter a valid phone number in the following format: (xxx) xxx-xxxx";
    }
  }

  changePrimaryMail(mail, index) {
    /* Validate valid email */
    var reBasicEmailValidation = /\S+@\S+\.\S+/;
    if (!reBasicEmailValidation.test(mail)) {
      return "Please enter a valid email address";
    }

    /* Change primary email */

    var primary = (index === 0);

    if (!primary)
      return;

    var defer = this.$q.defer();

    this.user.email = mail;

    this.Auth.changeEmail(this.user._id, mail).then(() =>{
      defer.resolve();
    }).catch(res => {
      defer.resolve(res.data.errors.email.message);
    });

    return defer.promise;
  }
}

export default angular.module('conduuApp.profile', [uiRouter])
  .config(routes)
  .component('profile', {
    template: require('./profile.html'),
    controller: ProfileComponent,
    controllerAs: 'profileCtrl',
    bindings: {
      type: '@'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/user/profile/profile.component.js